import DocumentCreatedEvent from '@/domains/documents/events/DocumentCreatedEvent';

const DocumentEvents = {
  DocumentCreated: DocumentCreatedEvent,
};

export default DocumentEvents;
